import moment from "moment";
import { useState } from "react";

export default function useWeekNavigator() {
    const [currentWeek, setCurrentWeek] = useState(moment().startOf('week'));
    const endOfCurrentWeek = moment(currentWeek).endOf('week');

    const goToPreviousWeek = () => {
        setCurrentWeek(prev => prev.clone().subtract(1, 'week'));
    };

    const goToNextWeek = () => {
        setCurrentWeek(prev => prev.clone().add(1, 'week'));
    };

    const getDaysOfWeek = (weekStart) => {
        return Array.from({ length: 7 }, (_, i) => ({
            day: weekStart.clone().add(i, 'days').format('YYYY-MM-DD'),
            renderDay: weekStart.clone().add(i, 'days').format('ddd MM/DD'),
        }));
    };

    const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const selectedDate = moment(e.target.value, 'YYYY-MM-DD');
        setCurrentWeek(selectedDate.startOf('week'));
    };

    return {
        currentWeek,
        endOfCurrentWeek,
        goToPreviousWeek,
        goToNextWeek,
        getDaysOfWeek,
        handleDateChange
    };
};
